import {createSlice} from "@reduxjs/toolkit";
import axiosInstance from "../../API/Axios/AxiosConfig";
import URLS from "../../API/Axios/URLS";

const initalState = {
    vocabulary: [],
    writing: [],
    reading: [],
    speaking: [],
    listening: [],
}


const GuideSlice = createSlice({
    name: "guide",
    initialState: initalState,
    reducers: {

        setGuide: (state, action) => {
            state = action.payload
            return state
        },
        updateGuide: (state, action) => {
            state = {
                ...state,
                ...action.payload
            }
            return state
        },
        resetGuide: (state, action) => {
            state = initalState
            return state
        }
    }
})


export const {setGuide, updateGuide, resetGuide} = GuideSlice.actions
export default GuideSlice.reducer